<div class="row content-margin g-0">

  @if (isLoading) {
    <p>{{'STANDARD.LOADING' | translate}}</p>
  } @else if (attachments.length === 0) {
    <p class="text-muted" data-cy="ticket-attachments-empty">{{'TICKET_ATTACHMENT.EMPTY' | translate}}</p>
  } @else {
    @for (attachment of attachments; track attachment.attachmentId) {
      <div class="card mt-1 mb-1 w-100" data-cy="ticket-attachment-card">
        <div class="card-body p-2">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 text-break">
              <strong data-cy="ticket-attachment-filename">{{ attachment.fileName }}</strong>
              <div class="text-muted small">{{ attachment.createdAt | date:'dd.MM.yyyy HH:mm' }}</div>
            </div>
            <div class="d-flex align-items-center flex-shrink-0 ms-2" style="white-space: nowrap;">
              <span class="badge me-2" [ngClass]="getBadgeClass(attachment.type)" data-cy="ticket-attachment-badge">
                {{ ('TICKET_ATTACHMENT.TYPE_' + attachment.type) | translate }}
              </span>
              <button class="btn btn-primary btn-sm mx-1"
                      (click)="downloadAttachment(attachment)"
                      data-cy="ticket-attachment-download-btn"
                      [title]="'TICKET_ATTACHMENT.DOWNLOAD_TITLE' | translate">
                <fa-icon [icon]="faDownload"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  }

</div>
